import { c as _c } from "react/compiler-runtime";
import { CountryEnum, Tooltip, getSingleCountry } from '@systemeio/ui';
import { StudentContactInterface } from 'modules/courses/students/types/student-interface';
import React, { type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePhoneInput } from 'shared/react-international-phone';
interface StudentContactTooltipProps {
  contact: StudentContactInterface;
  children: JSX.Element;
}
const StudentContactTooltip = t0 => {
  const $ = _c(64);
  const {
    contact,
    children
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== contact.phoneNumber) {
    t1 = {
      value: contact.phoneNumber
    };
    $[0] = contact.phoneNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    phone: formattedPhoneNumber
  } = usePhoneInput(t1);
  const customFields = contact.customFields;
  let t2;
  if ($[2] !== contact.email || $[3] !== t) {
    t2 = contact.email && <p><span className="text-text-primary font-bold">{t("global.email")}: </span><span>{contact.email}</span></p>;
    $[2] = contact.email;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== contact.firstName || $[6] !== t) {
    t3 = contact.firstName && <p><span className="text-text-primary font-bold">{t("dashboard.user.first_name")}:{" "}</span><span>{contact.firstName}</span></p>;
    $[5] = contact.firstName;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== contact.lastName || $[9] !== t) {
    t4 = contact.lastName && <p><span className="text-text-primary font-bold">{t("dashboard.user.last_name")}: </span><span>{contact.lastName}</span></p>;
    $[8] = contact.lastName;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== contact.streetAddress || $[12] !== t) {
    t5 = contact.streetAddress && <p><span className="text-text-primary font-bold">{t("dashboard.user.street_address")}:{" "}</span><span>{contact.streetAddress}</span></p>;
    $[11] = contact.streetAddress;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== contact.city || $[15] !== t) {
    t6 = contact.city && <p><span className="text-text-primary font-bold">{t("dashboard.user.city")}: </span><span>{contact.city}</span></p>;
    $[14] = contact.city;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== contact.postCode || $[18] !== t) {
    t7 = contact.postCode && <p><span className="text-text-primary font-bold">{t("dashboard.user.postal_code")}:{" "}</span><span>{contact.postCode}</span></p>;
    $[17] = contact.postCode;
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== contact.country || $[21] !== t || $[22] !== user?.dashboardLocale) {
    t8 = contact.country && <p><span className="text-text-primary font-bold">{t("dashboard.user.country")}: </span><span>{Object.values(CountryEnum).includes(contact.country) ? getSingleCountry(contact.country, user?.dashboardLocale) : contact.country}</span></p>;
    $[20] = contact.country;
    $[21] = t;
    $[22] = user?.dashboardLocale;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== contact.phoneNumber || $[25] !== formattedPhoneNumber || $[26] !== t) {
    t9 = contact.phoneNumber && <p><span className="text-text-primary font-bold">{t("dashboard.user.phone_number")}:{" "}</span><span>{formattedPhoneNumber}</span></p>;
    $[24] = contact.phoneNumber;
    $[25] = formattedPhoneNumber;
    $[26] = t;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== contact.taxCode || $[29] !== t) {
    t10 = contact.taxCode && <p><span className="text-text-primary font-bold">{t("dashboard.user.tax_number")}:{" "}</span><span>{contact.taxCode}</span></p>;
    $[28] = contact.taxCode;
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== contact.companyName || $[32] !== t) {
    t11 = contact.companyName && <p><span className="text-text-primary font-bold">{t("dashboard.user.company_name")}:{" "}</span><span>{contact.companyName}</span></p>;
    $[31] = contact.companyName;
    $[32] = t;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== customFields) {
    t12 = customFields && Object.keys(customFields).map(el => <p key={el}><span className="text-text-primary font-bold">{el}: </span><span>{customFields[el]}</span></p>);
    $[34] = customFields;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t) {
    t13 = t("dashboard.user.affiliate");
    $[36] = t;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t13) {
    t14 = <span className="text-text-primary font-bold">{t13}: </span>;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== contact.referredBy || $[41] !== t) {
    t15 = contact.referredBy ? contact.referredBy : t("global.none");
    $[40] = contact.referredBy;
    $[41] = t;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15) {
    t16 = <span>{t15}</span>;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t14 || $[46] !== t16) {
    t17 = <p>{t14}{t16}</p>;
    $[45] = t14;
    $[46] = t16;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t12 || $[51] !== t17 || $[52] !== t2 || $[53] !== t3 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6 || $[57] !== t7 || $[58] !== t8 || $[59] !== t9) {
    t18 = <div className="flex flex-col items-start gap-2">{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t17}</div>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t12;
    $[51] = t17;
    $[52] = t2;
    $[53] = t3;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t7;
    $[58] = t8;
    $[59] = t9;
    $[60] = t18;
  } else {
    t18 = $[60];
  }
  let t19;
  if ($[61] !== children || $[62] !== t18) {
    t19 = <Tooltip mode="hover" wrapperClassName="w-full" className="w-full max-w-fit truncate" label={t18}>{children}</Tooltip>;
    $[61] = children;
    $[62] = t18;
    $[63] = t19;
  } else {
    t19 = $[63];
  }
  return t19;
};
export default StudentContactTooltip;